import React, { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { translateUrl } from '@hozana/router/functions'

import { Button, TButtonProps } from 'elements/button/Button'
import { Div } from 'elements/layout/Div'
import { Space } from 'elements/layout/Space'
import { Icon } from 'elements/media/Icon'
import { P } from 'elements/text/P'
import { Text } from 'elements/text/Text'

import { ICON } from 'config/icons'
import { getConnectDetails } from 'general/functions'
import { newRoutes } from 'routes/constants'

const StyledButton = styled(Button)`
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  border-radius: ${(props) => props.theme.borderRadius.normal};
  &:hover svg,
  &:focus svg,
  &:hover ${Text}, &:focus ${Text} {
    color: white !important;
  }
`

export const SocialLoginNative: TFCC<TButtonProps> = ({ onClick, ...RestProps }) => {
  const {
    i18n: { language },
  } = useTranslation()

  const socialButtonClicked = () => {
    const messageProps = {
      action: 'social-auth',
      lang: language,
      redirectUrl: !!getConnectDetails().redirectUrl
        ? translateUrl(getConnectDetails().redirectUrl, language, { format: 'string' })
        : newRoutes.prayerSpace(),
      currentUrl: window.location.href,
    }

    window.postMessage(JSON.stringify(messageProps))
  }

  return (
    <StyledButton
      w="100%"
      bg="white"
      hoverBg="darkBlue"
      borderColor="white"
      type="button"
      onClick={(e: MouseEvent<HTMLButtonElement>) => {
        onClick?.(e)
        socialButtonClicked()
      }}
      bold={false}
      {...RestProps}
    >
      <P p="5px" color="darkBlue">
        trans:auth:auth.sign-up-or-login.with
      </P>
      <Space h="10px" />
      <Div p="5px" display="flex" align="middleCenter">
        <Icon vAlign="bottom" name={ICON.APPLE} size={'1.8em'} color="black" />
        <Icon vAlign="bottom" name={ICON.FACEBOOK} size={'1.8em'} color="facebook" m="0 0 0 10px" />
        <Icon vAlign="bottom" name={ICON.GOOGLE} size={'1.6em'} color="google" m="0 0 0 10px" />
      </Div>
    </StyledButton>
  )
}
